import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const navLinks = [
  { href: '#about', label: 'お店について' },
  { href: '#craft', label: 'こだわり' },
  { href: '#menu', label: 'メニュー' },
  { href: '#story', label: 'ストーリー' },
  { href: '#access', label: 'アクセス' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-cream shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <a
          href="#top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="cursor-pointer"
        >
          <img
            src="https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/a0fb5f46f0af3052b3f1292bd159d9f1.png"
            alt="ふぅばてぇ(FUBATE) ロゴ"
            className="h-10 w-auto object-contain"
          />
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className={`text-sm font-rounded font-medium cursor-pointer whitespace-nowrap transition-colors duration-200 ${
                scrolled ? 'text-kiln hover:text-tankan' : 'text-white hover:text-tankan-light'
              }`}
            >
              {link.label}
            </button>
          ))}
          <a
            href="tel:0997-69-4091"
            className="flex items-center gap-2 bg-tankan text-white text-sm font-rounded font-bold px-4 py-2 rounded-full whitespace-nowrap cursor-pointer hover:bg-tankan-dark transition-colors duration-200"
          >
            <i className="ri-phone-line text-base" />
            予約する
          </a>
        </nav>

        {/* Mobile menu toggle */}
        <button
          className={`md:hidden cursor-pointer transition-colors ${scrolled ? 'text-kiln' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </div>

      {/* Mobile drawer */}
      {menuOpen && (
        <div className="md:hidden bg-cream border-t border-cream-dark shadow-md">
          <nav className="flex flex-col py-4">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => handleNavClick(link.href)}
                className="text-left px-6 py-3 text-kiln font-rounded font-medium text-base cursor-pointer hover:bg-cream-dark transition-colors whitespace-nowrap"
              >
                {link.label}
              </button>
            ))}
            <div className="px-6 pt-3 pb-2">
              <a
                href="tel:0997-69-4091"
                className="flex items-center justify-center gap-2 bg-tankan text-white font-rounded font-bold px-4 py-3 rounded-full cursor-pointer hover:bg-tankan-dark transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line" />
                0997-69-4091
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
